import * as React from 'react';
import {
  DataTable,
  DetailTimeline,
  EmptyState,
  type DataTableColumn,
  type DataTableTexts,
  type ListQuery,
} from '@redhand/ui';
import { demoProperties, demoTimeline, queryDemoProperties, type DemoProperty } from '../../demo-data.js';

const texts: DataTableTexts = {
  paginationLabel: 'Stránkování',
  pageStatus: (page, pageCount, total) => `Stránka ${page} z ${pageCount} (celkem ${total} řádků)`,
  prev: 'Předchozí',
  next: 'Další',
  loading: 'Načítám seznam…',
  errorTitle: 'Načtení seznamu selhalo',
  retry: 'Zkusit znovu',
  exportCsv: 'Export CSV',
};

const ALL = demoProperties();

/** Vzorova obrazovka: Seznam + detail s timeline (master-detail vzor). */
export function SeznamSample(): React.JSX.Element {
  const [query, setQueryState] = React.useState<ListQuery>({ page: 1, pageSize: 50 });
  const [selectedId, setSelectedId] = React.useState<string>('P-0001');
  const data = queryDemoProperties(ALL, query);
  const selected = ALL.find((p) => p.id === selectedId);

  const columns: readonly DataTableColumn<DemoProperty>[] = [
    {
      key: 'name',
      header: 'Nemovitost',
      sortable: true,
      render: (r) => (
        <button
          type="button"
          className="rh-table__sort"
          style={{ textAlign: 'left', fontWeight: r.id === selectedId ? 650 : 400 }}
          onClick={() => setSelectedId(r.id)}
        >
          {r.name}
        </button>
      ),
    },
    { key: 'status', header: 'Stav', render: (r) => <span className="rh-badge rh-badge--neutral">{r.status}</span> },
    { key: 'price', header: 'Cena', align: 'right', sortable: true },
  ];

  return (
    <div>
      <header style={{ marginBottom: 20 }}>
        <h1 style={{ margin: 0, fontSize: 28, fontWeight: 650, letterSpacing: '-0.02em' }}>Nemovitosti</h1>
      </header>
      <div className="rh-today__columns">
        <DataTable<DemoProperty>
          caption="Seznam nemovitostí"
          columns={columns}
          rowKey={(r) => r.id}
          data={data}
          query={query}
          onQueryChange={(patch) => setQueryState((prev) => ({ ...prev, ...patch }))}
          onExport={() => {}}
          emptyState={<EmptyState title="Žádné nemovitosti" />}
          texts={texts}
        />
        <aside>
          <div className="rh-card">
            <h2 style={{ margin: '0 0 4px', fontSize: 16 }}>{selected ? selected.name : 'Vyber nemovitost'}</h2>
            {selected ? (
              <p style={{ margin: '0 0 16px', fontSize: 13, color: 'var(--rh-text-muted)' }}>
                Klient: {selected.client} · {selected.price}
              </p>
            ) : null}
            <h3 style={{ margin: '0 0 8px', fontSize: 14 }}>Historie</h3>
            <DetailTimeline ariaLabel="Historie nemovitosti" items={demoTimeline} />
          </div>
        </aside>
      </div>
    </div>
  );
}
